import React, { useState } from 'react';
import { getFirestore, addDoc, collection } from "firebase/firestore";
import ReCAPTCHA from "react-google-recaptcha";
import Footer from './components/Footer';
import './CreateAccount.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    message: '',
    email: '',
  });
  const [captchaValue, setCaptchaValue] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const db = getFirestore();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, subject, message, email } = formData;

    if (!name || !subject || !message) {
      setErrorMessage("Please fill out all required fields.");
      return;
    }

    if (!captchaValue) {
      setErrorMessage("Please complete the CAPTCHA.");
      return;
    }

    try {
      await addDoc(collection(db, "contactMessages"), {
        name,
        subject,
        message,
        email: email || null,
        timestamp: new Date(),
      });
      setSuccessMessage("Your message has been sent successfully!");
      setFormData({ name: '', subject: '', message: '', email: '' });
      setCaptchaValue(null);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage("Failed to send your message. Please try again.");
      console.error("Error adding document: ", error);
    }
  };

  return (
    <div>
    <div className="create-account-container">
      <div className="left-container">
        <div className="form-container">
        <h1><img src='/imgs/domorango.png' alt="Domogogo" className="" style={{maxWidth:"200px",paddingBottom:"30px"}} /></h1>
          <h2>Contact Us</h2>
          <p>We really want to hear from you, feel free to email us, Instagram us, or fill in the contact us form</p>
          <p><b>Email:</b> hello@domogogo.com</p>
          <p><b>Social:</b> <a href='https://www.instagram.com/domogogoapp' target="_blank" rel="noopener noreferrer" style={{color:'white'}}>Domogogo on Instagram</a></p>
        </div>
      </div>
      <div className="form-container">
        <div className="form-container-center-vertically">
          <h2>Get in Touch</h2>
          <form onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} className="input-field" required />
            <input type="text" name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} className="input-field" required />
            <textarea name="message" placeholder="Your Message" value={formData.message} onChange={handleChange} className="input-field" required></textarea>
            <input type="email" name="email" placeholder="Your Email (optional)" value={formData.email} onChange={handleChange} className="input-field" />
            <ReCAPTCHA sitekey="6LevKcQqAAAAAFzWU2Pmym6UbepoHJ9TpZyLDbRW" onChange={(value) => setCaptchaValue(value)} />
            <button type="submit" className="submit-contact-button">Send Message</button>
          </form>
          {successMessage && <p className="success-message">{successMessage}</p>}
          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
      </div>
    </div>
    <Footer />
    </div>
  );
};

export default ContactUs;
